class ProductTabs extends HTMLElement {
  constructor() {
    super();
    this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
    this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));
    this.tabs.forEach((tab) => {
      tab.addEventListener('click', () => this.selectTab(tab));
      tab.addEventListener('keydown', (event) => this.onKeydown(event, tab));
    });
  }

  selectTab(selectedTab) {
    this.tabs.forEach((tab) => {
      const isSelected = tab === selectedTab;
      tab.setAttribute('aria-selected', isSelected);
      const panel = this.querySelector(`#${tab.getAttribute('aria-controls')}`);
      if (!panel) return;
      panel.hidden = !isSelected;
    });
  }

  onKeydown(event, tab) {
    const currentIndex = this.tabs.indexOf(tab);
    let nextIndex = null;
    if (event.key === 'ArrowRight') {
      nextIndex = (currentIndex + 1) % this.tabs.length;
    } else if (event.key === 'ArrowLeft') {
      nextIndex = (currentIndex - 1 + this.tabs.length) % this.tabs.length;
    }
    if (nextIndex === null) return;
    event.preventDefault();
    this.tabs[nextIndex].focus();
    this.selectTab(this.tabs[nextIndex]);
  }
}

customElements.define('product-tabs', ProductTabs);
